import React, { useState, useEffect } from "react";

function Popup() {
  const [showPopup, setShowPopup] = useState(false);

  // Show popup automatically when page loads
  useEffect(() => {
    setShowPopup(true);
  }, []);

  const closePopup = () => {
    setShowPopup(false);
  };

  return (
    <div className="" >


      {/* Popup */}
      {showPopup && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" >
          <div className="bg-white p-6 rounded-2xl shadow-lg w-96 relative text-center" style={{ padding: '150px' }}>

            {/* <img src="https://www.spst.in/images/alert.jpeg" alt="popup" style={{width:'100%'}} /> */}
            {/* <button
              onClick={closePopup}
              className="absolute top-2 right-3 text-gray-500 hover:text-black text-xl"
            >
              ✕
            </button> */}

            <h2 className="text-xl font-semibold mb-3" style={{ fontWeight: '600', color: 'red' }}>ATTENTION DONORS</h2>
            <p className="mb-4" style={{ fontSize: '18pt', fontWeight: '600' }}>Devotees who are desirous of making donations either to Temple or for the ongoing Murajapam - Lakshadeepam 2025-26 are hereby informed, that Sree Padmanabha Swamy Temple Administration has not authorized any individual, group or organisation/association to solicit donation or collect money on the behalf of Sree Padmanabha Swamy Temple. Devotees are therefore strictly warned not to respond to any such request or call made by any such individual, or organisation in this regard. All such contribution shall be made only to the following accounts for the purpose noted against each.</p>
            <div style={{width:'400px',float:'left',border:'2px solid maroon',padding:'15px',height:'300px'}}>
              <p style={{fontSize:'15pt'}}>
                <b><u>Murajapam - Lakshadeepam Donations</u></b> <br />
               
                Alc Name: Murajapam-Lakshadeepam 2025-26. <br />
                A/C No.: <span style={{fontWeight:'800',color:'maroon'}}>0820101027466</span> <br />
                IFSC Code: <span style={{fontWeight:'800',color:'maroon'}}>CNRB0014005</span>

              </p>
            </div>
            <div style={{width:'400px',float:'left',border:'2px solid maroon',padding:'15px',height:'300px'}}>
              <p style={{fontSize:'15pt'}}>
                <b><u>Other Donations</u></b> <br />
               
                Alc Name: SREE PADMANABHA SWAMY TEMPLE <br />
                A/C No.: <span style={{fontWeight:'800',color:'maroon'}}>40052010005831</span> <br />
                IFSC Code: <span style={{fontWeight:'800',color:'maroon'}}>CNRB0014005</span>

              </p>
            </div>


            <button
              onClick={closePopup}
              className="bg-blue-600  px-4 py-2 rounded-lg hover:bg-blue-700" style={{background:'orange',color:'maroon',fontWeight:'700'}}
            >
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default Popup;
